import React from 'react'
/* import DatePicker from "react-datepicker" */
const Dob = props => {
  // props for this file from another
  const { inputData, sendinputdata, sendtruevalue, disableInput } = props

  // function to set dateofbirth
  const dobfun = date => {
    const inputData1 = { ...inputData }
    inputData1.dateOfBirth = date.target.value
    sendinputdata(inputData1)
    sendtruevalue('dob', true)
  }

  return (
    <div>
      <div className='shotbio'>
        <label>DOB:</label>
        {/* input place to enter or select date from calander */}
        <input
          type='date'
          value={inputData.dateOfBirth}
          onChange={date => dobfun(date)}
          disabled={disableInput === true}
        />
      </div>
    </div>
  )
}

export default Dob
